"use client";

import Link from "next/link";
import { LogInIcon } from "lucide-react";

import { Button } from "@acme/ui/button";

interface SignInButtonProps {
  pathname: string;
}

export function SignInButton({ pathname }: SignInButtonProps) {
  return (
    <Button
      variant="ghost"
      size="xs"
      className="flex items-center gap-2"
      asChild
    >
      <Link href={`/login?redirect=${pathname}`}>
        <LogInIcon className="size-4" />
        Sign in
      </Link>
    </Button>
  );
}
